import { MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { waLink } from "../data/site";

export const FinalCTA = ({ onBook }) => {
    return (
        <section data-testid="final-cta-section" className="relative py-32 lg:py-44 px-6 overflow-hidden">
            <div className="absolute inset-0 -z-10">
                <img
                    src="https://images.unsplash.com/photo-1608501821300-4f99e58bba77?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920"
                    alt=""
                    className="w-full h-full object-cover opacity-30 ink-pulse"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-[#081226] via-[#081226]/60 to-[#081226]" />
            </div>

            <Reveal className="max-w-4xl mx-auto text-center">
                <h2 className="font-display text-4xl sm:text-5xl lg:text-7xl font-black tracking-tight text-[#F0EBE0] leading-tight">
                    Your Ink. Your Numbers.<br />
                    <span className="italic text-[#C9A962] text-glow-gold">Your Story.</span>
                </h2>
                <p className="mt-6 text-base lg:text-lg font-light text-[#A19D94]">Ready to discover what they reveal?</p>
                <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
                    <button
                        data-testid="final-book-btn"
                        onClick={onBook}
                        className="px-10 py-4 rounded-full bg-[#C9A962] text-[#081226] text-sm font-semibold uppercase tracking-[0.15em] hover:bg-[#dcc083] hover:shadow-[0_0_45px_rgba(201,169,98,0.5)] hover:-translate-y-0.5 transition-all"
                    >
                        Book Your Consultation
                    </button>
                    <a
                        data-testid="final-whatsapp-btn"
                        href={waLink("Hi Maitrii! I'd like to book a consultation.")}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="px-10 py-4 rounded-full border border-[#C9A962]/40 text-[#C9A962] text-sm font-semibold uppercase tracking-[0.15em] hover:bg-[#C9A962]/10 hover:border-[#C9A962] transition-all flex items-center gap-2"
                    >
                        <MessageCircle size={16} /> WhatsApp Us
                    </a>
                </div>
            </Reveal>
        </section>
    );
};
